import Lockr from 'lockr';
import { clearApolloCache } from 'v2/utils/clearCache';

export const navigateToTenant = async <T extends { slug?: string }>(
  tenant: T,
  isDemoTenant: boolean = false,
) => {
  sessionStorage.removeItem('isDemoTenant');
  if (isDemoTenant) {
    sessionStorage.setItem('isDemoTenant', JSON.stringify(true));
  }

  Lockr.set('adminTenant', tenant);
  Lockr.set('tenant', tenant);

  await clearApolloCache();

  window.location.href = tenant.slug ? `/${tenant.slug}` : '/';
};
